export const ADMIN_ANALYZE_LAYOUT_TK = "ADMIN_ANALYZE_LAYOUT_TK";
